<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="4" :sm="24">
                <a-form-item label="单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入FTDD单号查询" v-model="queryParam.billNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择客户" allow-clear v-model="queryParam.customerTenantId">
                    <a-select-option v-for="p in partnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
                      {{ p.partnerName }}（{{ p.partnerTenantId }}）
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择审核状态" allow-clear v-model="queryParam.auditStatus">
                    <a-select-option value="1">已审核(默认)</a-select-option>
                    <a-select-option value="0">未审核</a-select-option>
                    <a-select-option value="9">审核中</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="3" :sm="24">
                <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择状态" allow-clear v-model="queryParam.status">
                    <a-select-option value="0">待校正</a-select-option>
                    <a-select-option value="1">已生成订单</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="queryTimeRange"
                    @change="onTimeChange" />
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="3" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新建发图单</a-button>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="auditStatus" slot-scope="text">
              <a-tag v-if="text === '0'" color="red">未审核</a-tag>
              <a-tag v-else-if="text === '9'" color="orange">审核中</a-tag>
              <a-tag v-else color="green">已审核</a-tag>
            </template>
            <template slot="status" slot-scope="text">
              <a-tag v-if="text === '0'" color="orange">待校正</a-tag>
              <a-tag v-else color="green">已生成订单</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="goWorkbench(record)">校正工作台</a>
              <a-popconfirm v-if="record.auditStatus === '0' && canAudit" style="margin-left: 8px"
                        title="确定审核通过该发图单吗?" @confirm="() => handleAudit(record)">
                <a>审核</a>
              </a-popconfirm>
              <a-popconfirm v-if="record.auditStatus === '0' && canSubmitFlow" style="margin-left: 8px"
                        title="确定提交该发图单至审批流程吗?" @confirm="() => handleSubmitFlow(record)">
                <a>提交流程</a>
              </a-popconfirm>
              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" style="margin-left: 8px"
                        title="确定删除该发图单吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />

        <!-- ========== 新建发图单弹窗 ========== -->
        <a-modal
          title="新建发图单"
          :width="600"
          :visible="addModalVisible"
          :confirmLoading="addSaving"
          :maskClosable="false"
          @ok="handleAddOk"
          @cancel="addModalVisible = false"
          cancelText="取消"
          okText="保存"
          style="top:100px;">
          <a-form>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户" required>
              <a-select placeholder="请选择已绑定的客户" v-model="addForm.customerTenantId" show-search
                        :filter-option="filterPartnerOption">
                <a-select-option v-for="p in partnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
                  {{ p.partnerName }}（{{ p.partnerTenantId }}）
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图片地址" required
                         extra="一期暂支持手填图片URL，每行一个地址（后续接入OSS上传后可直接粘贴）">
              <a-textarea placeholder="请输入图片地址，每行一个" :rows="6" v-model="addForm.imageUrlsText" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input placeholder="请输入备注" v-model="addForm.remark" />
            </a-form-item>
          </a-form>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getPartners, addImgOrder, deleteImgOrder, getImgAuditConfig, auditImgOrder, submitWorkflowTask } from '@/api/plugin/orderReceive'

export default {
  name: 'ImgOrderList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      queryParam: {
        billNo: '',
        customerTenantId: undefined,
        status: undefined,
        auditStatus: '1',
        beginTime: '',
        endTime: ''
      },
      // 发图单（FTDD）审核配置：决定未审核行显示"审核"还是"提交流程"
      auditConfig: { multiOn: false, flowOn: false },
      queryTimeRange: [],
      partnerList: [],
      addModalVisible: false,
      addSaving: false,
      addForm: {
        customerTenantId: undefined,
        imageUrlsText: '',
        remark: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '单号',
          dataIndex: 'billNo',
          width: 180
        },
        {
          title: '客户',
          dataIndex: 'customerName',
          width: 160
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'auditStatus' }
        },
        {
          title: '图片数',
          dataIndex: 'imgCount',
          width: 80,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 210,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/img-orders'
      }
    }
  },
  computed: {
    // 未审核行显示"审核"：未开启多级审核，或开启但未配置流程（口径同 ApprovalButtonMixin）
    canAudit() {
      return !this.auditConfig.multiOn || !this.auditConfig.flowOn
    },
    // 未审核行显示"提交流程"：开启多级审核且已配置发布流程
    canSubmitFlow() {
      return this.auditConfig.multiOn && this.auditConfig.flowOn
    }
  },
  created() {
    this.loadPartners()
    this.loadAuditConfig()
  },
  methods: {
    // 发图单（FTDD）审核配置：决定未审核行显示"审核"还是"提交流程"
    loadAuditConfig() {
      getImgAuditConfig('FTDD').then((res) => {
        if (res.code === 200 && res.data) {
          this.auditConfig = { multiOn: !!res.data.multiOn, flowOn: !!res.data.flowOn }
        }
      })
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        billNo: this.queryParam.billNo,
        customerTenantId: this.queryParam.customerTenantId,
        status: this.queryParam.status,
        auditStatus: this.queryParam.auditStatus,
        beginTime: this.queryParam.beginTime,
        endTime: this.queryParam.endTime
      }
    },
    // 重置查询（覆盖 mixin，同步清空时间区间）
    searchReset() {
      this.queryTimeRange = []
      this.queryParam = {
        billNo: '',
        customerTenantId: undefined,
        status: undefined,
        auditStatus: '1',
        beginTime: '',
        endTime: ''
      }
      this.loadData(1)
    },
    // 已绑定客户下拉选项（新建/筛选共用）
    loadPartners() {
      getPartners({ currentPage: 1, pageSize: 100 }).then((res) => {
        if (res.code === 200) {
          const rows = (res.data && res.data.rows) || []
          this.partnerList = rows
        }
      })
    },
    onTimeChange(dates) {
      if (dates && dates.length === 2) {
        this.queryParam.beginTime = dates[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.endTime = dates[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    filterPartnerOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) > -1
    },
    handleAdd() {
      this.addForm = { customerTenantId: undefined, imageUrlsText: '', remark: '' }
      this.addModalVisible = true
    },
    handleAddOk() {
      if (!this.addForm.customerTenantId) {
        this.$message.warning('请选择客户')
        return
      }
      const imageUrls = (this.addForm.imageUrlsText || '')
        .split('\n').map((s) => s.trim()).filter((s) => s.length > 0)
      if (imageUrls.length === 0) {
        this.$message.warning('请至少填写一张图片地址')
        return
      }
      this.addSaving = true
      addImgOrder({
        customerTenantId: this.addForm.customerTenantId,
        imageUrls: imageUrls,
        remark: this.addForm.remark
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('创建成功，单号 ' + ((res.data && res.data.billNo) || ''))
          this.addModalVisible = false
          this.loadData(1)
        } else {
          this.$message.warning(res.message || '创建失败')
        }
      }).finally(() => {
        this.addSaving = false
      })
    },
    handleDelete(id) {
      deleteImgOrder(id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    // 审核发图单（'0'未审核 →'1'已审核，审核后进入正常工作台）
    handleAudit(record) {
      auditImgOrder(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('审核成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '审核失败')
        }
      })
    },
    // 提交发图单至审批流程（bigType=10 发图单）
    handleSubmitFlow(record) {
      submitWorkflowTask(10, record.billNo).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('提交流程成功')
          this.loadData()
        } else {
          this.$message.warning((res && res.data && res.data.message) || '提交流程失败')
        }
      })
    },
    // 跳转 OCR 校正工作台（携带 query.id）
    goWorkbench(record) {
      this.$router.push({ path: '/plugin/order-receive/imgorder/workbench', query: { id: record.id, from: 'receive' } })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.table-operator { margin-bottom: 15px; }
</style>
